import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/scan-empty-state.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_2 from '@/app/ui/assets/svg/close-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1ffb8b36")

_pushScopeId("data-v-1ffb8b36")
const _hoisted_1 = { class: "flex flex-col w-full items-center" }
const _hoisted_2 = {
  class: "relative w-full",
  style: {"min-height":"220px"}
}
const _hoisted_3 = { class: "absolute top-5 left-0" }
const _hoisted_4 = { class: "relative w-full" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-3 justify-center items-center w-full"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "empty-state"
}, null, -1)
const _hoisted_7 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col gap-7 justify-center items-center w-full top-3"
}
const _hoisted_9 = { class: "flex flex-row gap-1" }
const _hoisted_10 = { class: "font-bold text-sm text-gray-lp-300" }
const _hoisted_11 = { class: "font-normal text-sm text-gray-lp-300" }
const _hoisted_12 = {
  key: 0,
  class: "p-0.5",
  src: _imports_1,
  alt: "success"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_2,
  alt: "error"
}
const _hoisted_14 = { class: "absolute top-1 right-0" }
const _hoisted_15 = { class: "input-scan w-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_lp_input = _resolveComponent("lp-input")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_Transition, { name: "summary-card" }, {
          default: _withId(() => [
            (_ctx.scanNo && _ctx.SummarySummaryLocalStorage.dtDemTotal > 0 && _ctx.SummarySummaryLocalStorage.dtDemTotalNow >= 0)
              ? (_openBlock(), _createBlock(_component_SummaryCard, {
                  key: 0,
                  posName: _ctx.valueSummary,
                  current: _ctx.SummarySummaryLocalStorage.dtDemTotalNow,
                  total: _ctx.SummarySummaryLocalStorage.dtDemTotal,
                  demStatus: _ctx.demStatus
                }, null, 8, ["posName", "current", "total", "demStatus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.scanData.length < 1 && !_ctx.errorScan)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("dispatch.updatePrompt")), 1)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("img", {
                src: _ctx.scanIllustration,
                alt: "illustration",
                class: "mt-3"
              }, null, 8, ["src"]),
              _createVNode("div", {
                class: ["flex flex-row p-2 rounded-lg border border-gray-lp-2100 items-center", `${_ctx.backgroundStyling}`]
              }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("p", _hoisted_10, _toDisplayString(_ctx.scanNo), 1),
                  _createVNode("p", _hoisted_11, _toDisplayString(_ctx.scanMessage), 1)
                ]),
                _withDirectives(_createVNode("div", null, [
                  (_ctx.isDuplicateScan || (_ctx.scanStatus === 'success' && !_ctx.errorScan))
                    ? (_openBlock(), _createBlock("img", _hoisted_12))
                    : (_openBlock(), _createBlock("img", _hoisted_13))
                ], 512), [
                  [_vShow, _ctx.scanStatus !== 'partial' || _ctx.errorScan]
                ])
              ], 2)
            ])),
        _createVNode("div", _hoisted_14, [
          _createVNode(_Transition, { name: "notification" }, {
            default: _withId(() => [
              _createVNode(_component_ScanFailedCard, {
                data: _ctx.scanFailedList,
                title: _ctx.$t('dispatch.scanFailedListTitle'),
                isDispatch: "",
                dataDirection: "flex-col"
              }, null, 8, ["data", "title"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_lp_input, {
        modelValue: _ctx.clearScan,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearScan = $event)),
        sizeInput: "24px",
        bold: true,
        labelStacked: _ctx.$t('dispatch.scanExample'),
        placeholder: _ctx.$t('dispatch.scanPlaceholder'),
        onEnter: _ctx.onScan
      }, null, 8, ["modelValue", "labelStacked", "placeholder", "onEnter"])
    ])
  ]))
})